import { useEffect, useState } from "react";
import DynamicText from "./DynamicText.tsx";
import { useFlowStore } from "../../store/FlowStateStore.ts";
import { CanvasNode, CanvasNodeData } from "../../models/CanvasNode.ts";
import axios from "axios";
import LinkHandler from "./LinkHandler.tsx";
import { Environment as environment } from "../../environment.ts";

interface Attribute {
    attributeId: string;
    attributeName: string;
    businessId: string;
}

const Question = (data) => {

    const [question, setQuestion] = useState<string>("");
    const [attribute, setAttribute] = useState<string>("");
    const [attributeType, setAttributeType] = useState<string>("ANY");
    const [noOfAttempts, setNoOfAttempts] = useState<number>(1);
    const [error, setError] = useState<string>("");
    const [regex, setRegex] = useState<string>("");
    const [min, setMin] = useState<number>();
    const [max, setMax] = useState<number>();

    const { nodes, setNodes, businessId } = useFlowStore();
    const [attributes, setAttributes] = useState<Attribute[]>([]);

    useEffect(() => {
        const node = nodes.find((n) => n.data.id === data.nodeId);
        if (node) {
            const content = (node.data as CanvasNodeData).content.find((c) => c.id === data.subNodeId);
            if (content?.data) {
                const d = content.data as any;
                setQuestion(d.text || "");
                setAttribute(d.attribute || "");
                setAttributeType(d.attributeFormat || "ANY");
                setNoOfAttempts(d.attributeNumberOfAttempt ?? 1);
                setError(d.errorMessage || "");
                if (d.attributeFormatValue) {
                    setRegex(d.attributeFormatValue.regex || "");
                    setMin(d.attributeFormatValue.min);
                    setMax(d.attributeFormatValue.max);
                }
            }
        }
    }, []);

    const savedAttribute = (() => {
        const node = nodes.find((n) => n.data.id === data.nodeId);
        if (node) {
            const content = (node.data as CanvasNodeData).content.find((c) => c.id === data.subNodeId);
            return (content?.data as any)?.attribute || "";
        }
        return "";
    })();

    const getAllAtributes = () => {
        const payload = {
            businessId: businessId,
            page: 0,
            size: 100
        }
        axios.put(`${environment.baseUrl}/fetch/attribute`, payload).then((response) => {
            setAttributes(response.data.data.data);
            if (!savedAttribute) {
                setAttribute(response.data.data.data[0].attributeName);
            }
        }).catch((error) => { });
    }

    useEffect(() => {
        getAllAtributes();
    }, []);

    useEffect(() => {
        const updatedNodes = nodes.map((node) => {
            if (node.data.id == data.nodeId) {
                return {
                    ...node,
                    data: {
                        ...node.data,
                        content: [...(node.data as CanvasNodeData).content.map((nodeContent) => {
                            if (nodeContent.id == data.subNodeId) {
                                return {
                                    ...nodeContent,
                                    data: {
                                        attribute: attribute,
                                        attributeFormat: attributeType,
                                        attributeNumberOfAttempt: noOfAttempts,
                                        text: question,
                                        errorMessage: error,
                                        attributeFormatValue: {
                                            min: min,
                                            max: max,
                                            regex: regex
                                        }
                                    }
                                }
                            }
                            return nodeContent
                        })]
                    }
                }
            }
            return node;
        });
        setNodes([...(updatedNodes as CanvasNode[])]);
    }, [question, attribute, attributeType, noOfAttempts, min, max, regex, error]);

    return (
        <div className="node-body">
            <div>
                <span className="font-label">Question</span>
                <DynamicText
                    placeholder="Your Question"
                    value={question}
                    setValue={(val) => setQuestion(val)}
                    maxLength={1024}
                />
            </div>
            <div>
                <span className="font-label">Capture answer attribute</span>
                <select value={attribute} onChange={(event) => setAttribute(event.target.value)}>
                    {
                        attributes.map((attr) => {
                            return (<option value={attr.attributeName}>{attr.attributeName}</option>)
                        })
                    }
                </select>
            </div>
            <div>
                <span className="font-label">Select media type</span>
                <select value={attributeType} onChange={(event) => setAttributeType(event.target.value)}>
                    <option value="ANY">Any</option>
                    <option value="TEXT">Text</option>
                    <option value="NUMBER">Number</option>
                    <option value="EMAIL">Email</option>
                    <option value="REGEX">Regex</option>
                </select>
            </div>

            {attributeType == 'REGEX' && <div>
                <span className="font-label">Enter or paste regex</span>
                <input
                    type="text"
                    placeholder="Type regex.."
                    value={regex}
                    onChange={(event) => setRegex(event.target.value)}
                />
            </div>}
            {attributeType == 'NUMBER' && <div>
                <span className="font-label">Enter min max value</span>
                <div style={{ display: 'flex', gap: '5px' }}>
                    <input
                        type="number"
                        placeholder="min"
                        value={min}
                        onChange={(event) => setMin(parseInt(event.target.value))}
                    />
                    <input
                        type="number"
                        placeholder="max"
                        value={max}
                        onChange={(event) => setMax(parseInt(event.target.value))}
                    />
                </div>
            </div>}
            <div>
                <span className="font-label">Number of attempt</span>
                <input
                    type="number"
                    placeholder="Number of attempts"
                    min={1}
                    value={noOfAttempts}
                    onChange={(event) => setNoOfAttempts(parseInt(event.target.value))}
                />
            </div>
            <div>
                <span className="font-label">Enter Validation error message</span>
                <DynamicText
                    maxLength={72}
                    placeholder="Error message"
                    value={error}
                    setValue={(val) => setError(val)}
                />

                <LinkHandler />
            </div>

        </div>
    )
}

export default Question;
